"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespaces = exports.languageCodes = void 0;
exports.languageCodes = ["de", "en-gb", "es", "it", "pl", "pt", "sv", "tr"];
exports.namespaces = ["materials", "products", "FilePurpose", "countries"];
const translations = {
    "de": {
        "materials": {
            "brushed-silver": {
                "name": "Gebürstetes Silber"
            },
            "banner": {
                "name": "Banner"
            },
            "eco-friendly-clear": {
                "name": "Umweltfreundlich transparent"
            },
            "eco-friendly": {
                "name": "Umweltfreundlich"
            },
            "fluorescent-orange": {
                "name": "Neon Orange"
            },
            "fluorescent-pink": {
                "name": "Neon Pink"
            },
            "fluorescent-red": {
                "name": "Neon Rot"
            },
            "fluorescent-yellow": {
                "name": "Neon Gelb"
            },
            "front-adhesive": {
                "name": "Hinterglas"
            },
            "glitter": {
                "name": "Glitzer"
            },
            "heavy-duty": {
                "name": "Schwerlast"
            },
            "heavy-duty-clear": {
                "name": "Schwerlast transparent "
            },
            "holographic": {
                "name": "Holografisch"
            },
            "mirror-gold": {
                "name": "Gold Chrom"
            },
            "mirror-silver": {
                "name": "Silber Chrom"
            },
            "paper-biodegradable": {
                "name": "Biologisch abbaubares Papier"
            },
            "transfer-black": {
                "name": "Transfer schwarz"
            },
            "transfer-white": {
                "name": "Transfer weiß"
            },
            "vinyl-clear": {
                "name": "Transparentes Vinyl"
            },
            "vinyl-white": {
                "name": "Weißes Vinyl"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "PVC Banner"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Biologisch abbaubare Papierbögen"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Gestanzte Bögen"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Umweltfreundliche transparente Bögen"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Umweltfreundliche Bögen"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Glitzer Bögen"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Holografische Bögen"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Silber Chrom Bögen"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Transparente Bögen"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Bögen aus weißen Vinyl"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Muster"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Transparente Sticker Muster"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Gestanzte Sticker Muster"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Umweltfreundliche Sticker Muster"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Umweltfreundliche transparente Sticker Muster"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Hinterglasaufkleber Muster"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Angestanzte Sticker Muster"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer Muster"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Neon Sticker Muster"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Schwerlastaufkleber Muster"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Glitzer Sticker Muster"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Gold Chrom Sticker Muster"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Silber Chrom Sticker Muster"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Holografische Sticker Muster"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biologisch abbaubare Sticker Muster"
            },
            "SSK-CUSTOM": {
                "name": "Personalisiertes Stickerset für Elektroroller"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Transparente Sticker"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Klare Sticker "
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Fahrradaufkleber"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Autoaufkleber"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Runde Sticker"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Gestanzte Sticker"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Umweltfreundliche Sticker"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Umweltfreundliche transparente Sticker"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Hinterglasaufkleber"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Angestanzte Sticker"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Laptopaufkleber"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Logo Sticker"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Tassen Sticker"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Ovale Sticker"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Handyaufkleber"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Rechteckige Sticker"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Sticker mit abgerundeten Ecken"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Quadratische Sticker"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer Sticker"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Wasserflaschenaufkleber"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Wasserfeste Sticker"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Fensteraufkleber"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Neon Sticker"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Schwerlastaufkleber"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Glitzer Sticker"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Gold Chrom Sticker"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Silber Chrom Sticker"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Holografische Sticker"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Bögen"
            },
            "STICKER-WHITE-ALL": {
                "name": "Sticker aus weißem Vinyl"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biologisch abbaubare Sticker"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Kundenvorlage",
            "PurposeCutFile": "Schnittdatei",
            "PurposeDesignWorkingFile": "Arbeitsdatei erstellen",
            "PurposePrintReadyArtwork": "Druckfertige Vorlage",
            "PurposeProof": "Entwurf Bitmap",
            "PurposeProductSpecification": "Produktdetails"
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albanien",
            "DZ": "Algerien",
            "AS": "Amerikanischen Samoa-Inseln",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarktis",
            "AG": "Antigua und Barbuda",
            "AR": "Argentinien",
            "AM": "Armenien",
            "AW": "Aruba",
            "AU": "Australien",
            "AT": "Österreich",
            "AZ": "Aserbaidschan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesch",
            "BB": "Barbados",
            "BY": "Weißrussland",
            "BE": "Belgien",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivien",
            "BA": "Bosnien und Herzegowina",
            "BW": "Botswana",
            "BV": "Bouvet-Insel",
            "BR": "Brasilien",
            "IO": "Britisches Territorium des Indischen Ozeans",
            "BN": "Brunei Darussalam",
            "BG": "Bulgarien",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Kambodscha",
            "CM": "Kamerun",
            "CA": "Kanada",
            "CV": "Kap Verde",
            "KY": "Cayman Inseln",
            "CF": "Zentralafrikanische Republik",
            "TD": "Tschad",
            "CL": "Chile",
            "CN": "China",
            "CX": "Weihnachtsinsel",
            "CC": "Kokosinseln (Keelinginseln)",
            "CO": "Kolumbien",
            "KM": "Komoren",
            "CG": "Kongo",
            "CD": "Kongo, Demokratische Republik",
            "CK": "Cookinseln",
            "CR": "Costa Rica",
            "CI": "Elfenbeinküste",
            "HR": "Kroatien",
            "CU": "Kuba",
            "CY": "Zypern",
            "CZ": "Tschechien",
            "DK": "Dänemark",
            "DJ": "Dschibuti",
            "DM": "Dominica",
            "DO": "Dominikanische Republik",
            "TP": "Osttimor",
            "EC": "Ecuador",
            "EG": "Ägypten",
            "SV": "El Salvador",
            "GQ": "Äquatorialguinea",
            "ER": "Eritrea",
            "EE": "Estland",
            "ET": "Äthiopien",
            "FK": "Falklandinseln (Malvinas)",
            "FO": "Färöer Inseln",
            "FJ": "Fidschi",
            "FI": "Finnland",
            "FR": "Frankreich",
            "GF": "Französisch-Guayana",
            "PF": "Französisch Polynesien",
            "TF": "Südfranzösische Territorien",
            "GA": "Gabun",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Deutschland",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Griechenland",
            "GL": "Grönland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HM": "Heard Island und McDonald-Inseln",
            "VA": "Heiliger Stuhl (Staat der Vatikanstadt)",
            "HN": "Honduras",
            "HK": "Hongkong",
            "HU": "Ungarn",
            "IS": "Island",
            "IN": "Indien",
            "ID": "Indonesien",
            "IR": "Iran, Islamische Republik",
            "IQ": "Irak",
            "IE": "Irland",
            "IL": "Israel",
            "IT": "Italien",
            "JM": "Jamaika",
            "JP": "Japan",
            "JO": "Jordanien",
            "KZ": "Kasachstan",
            "KE": "Kenia",
            "KI": "Kiribati",
            "KP": "Korea, Demokratische Volksrepublik",
            "KR": "Korea, Republik",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kirgisistan",
            "LA": "Demokratische Volksrepublik Laos",
            "LV": "Lettland",
            "LB": "Libanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libysche Araber Jamahiriya",
            "LI": "Liechtenstein",
            "LT": "Litauen",
            "LU": "Luxemburg",
            "MO": "Macao",
            "MK": "Mazedonien",
            "MG": "Madagaskar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Malediven",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshallinseln",
            "MQ": "Martinique",
            "MR": "Mauretanien",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Mexiko",
            "FM": "Mikronesien, Föderierte Staaten von",
            "MD": "Moldawien, Republik",
            "MC": "Monaco",
            "MN": "Mongolei",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Marokko",
            "MZ": "Mosambik",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Niederlande",
            "AN": "Niederländische Antillen",
            "NC": "Neu-Kaledonien",
            "NZ": "Neuseeland",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolkinsel",
            "MP": "Nördliche Marianneninseln",
            "NO": "Norwegen",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Palästinensische Gebiete, besetzt",
            "PA": "Panama",
            "PG": "Papua Neu-Guinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Philippinen",
            "PN": "Pitcairn",
            "PL": "Polen",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Katar",
            "RE": "Wiedervereinigung",
            "RO": "Rumänien",
            "RU": "Russische Föderation",
            "RW": "Ruanda",
            "SH": "St. Helena",
            "KN": "St. Kitts und Nevis",
            "LC": "St. Lucia",
            "PM": "Saint Pierre und Miquelon",
            "VC": "St. Vincent und die Grenadinen",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "São Tomé and Príncipe",
            "SA": "Saudi-Arabien",
            "SN": "Senegal",
            "RS": "Serbien",
            "SC": "Seychellen",
            "SL": "Sierra Leone",
            "SG": "Singapur",
            "SK": "Slowakei",
            "SI": "Slowenien",
            "SB": "Salomon-Inseln",
            "SO": "Somalia",
            "ZA": "Südafrika",
            "GS": "Süd-Georgien und die südlichen Sandwich-Inseln",
            "ES": "Spanien",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Surinam",
            "SJ": "Svalbard And Jan Mayen Inseln",
            "SZ": "Swasiland",
            "SE": "Schweden",
            "CH": "Schweiz",
            "SY": "Syrische Arabische Republik",
            "TW": "Taiwan, chinesische Provinz",
            "TJ": "Tadschikistan",
            "TZ": "Tansania, Vereinigte Republik",
            "TH": "Thailand",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad und Tobago",
            "TN": "Tunesien",
            "TR": "Türkei",
            "TM": "Turkmenistan",
            "TC": "Turks- und Caicosinseln",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukraine",
            "AE": "Vereinigte Arabische Emirate",
            "GB": "Vereinigtes Königreich",
            "US": "Vereinigte Staaten",
            "UM": "Kleinere vorgelagerte Inseln der Vereinigten Staaten",
            "UY": "Uruguay",
            "UZ": "Usbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "VG": "Britische Jungferninseln",
            "VI": "Jungferninseln, USA",
            "WF": "Wallis und Futuna",
            "EH": "Westsahara",
            "YE": "Jemen",
            "ZM": "Sambia",
            "ZW": "Zimbabwe"
        }
    },
    "en-gb": {
        "materials": {
            "brushed-silver": {
                "name": "Brushed Silver"
            },
            "banner": {
                "name": "Banner"
            },
            "canvas": {
                "name": "Canvas"
            },
            "eco-friendly-clear": {
                "name": "Eco-friendly Clear"
            },
            "eco-friendly": {
                "name": "Eco-friendly"
            },
            "fluorescent-orange": {
                "name": "Fluorescent Orange"
            },
            "fluorescent-pink": {
                "name": "Fluorescent Pink"
            },
            "fluorescent-red": {
                "name": "Fluorescent Red"
            },
            "fluorescent-yellow": {
                "name": "Fluorescent Yellow"
            },
            "front-adhesive": {
                "name": "Front Adhesive"
            },
            "glitter": {
                "name": "Glitter"
            },
            "heavy-duty": {
                "name": "Heavy Duty"
            },
            "heavy-duty-clear": {
                "name": "Clear Heavy Duty"
            },
            "holographic": {
                "name": "Holographic"
            },
            "magnet": {
                "name": "Magnet"
            },
            "mirror-gold": {
                "name": "Mirror Gold"
            },
            "mirror-silver": {
                "name": "Mirror Silver"
            },
            "paper-biodegradable": {
                "name": "Biodegradable Paper"
            },
            "poster": {
                "name": "Poster"
            },
            "transfer-black": {
                "name": "Transfer Black"
            },
            "transfer-white": {
                "name": "Transfer White"
            },
            "vinyl-clear": {
                "name": "Clear Vinyl"
            },
            "vinyl-white": {
                "name": "White Vinyl"
            },
            "vinyl-floor": {
                "name": "Floor"
            },
            "vinyl-wall": {
                "name": "wall"
            },
            "wallpaper": {
                "name": "Wallpaper"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "PVC Banner"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Biodegradable paper sheet labels"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Die cut sheet labels"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Eco-friendly clear sheet labels"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Eco-friendly sheet labels"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Glitter sheet labels"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Holographic sheet labels"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Mirror silver sheet labels"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Clear vinyl sheet labels"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "White vinyl sheet labels"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Sticker sample pack"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Clear sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Die cut sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Eco-friendly sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Eco-friendly clear sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Front adhesive sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Kiss cut sticker samples"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer sticker samples"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Fluorescent sticker samples"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Heavy duty sticker samples"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Glitter sticker samples"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Mirror gold sticker samples"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Mirror silver sticker samples"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Holographic sticker samples"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biodegradable paper sticker samples"
            },
            "SSK-CUSTOM": {
                "name": "Custom electric scooter sticker kit"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Clear stickers"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Transparent stickers"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Bicycle stickers"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Car stickers"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Circle stickers"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Die cut stickers"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Eco-friendly stickers"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Eco-friendly clear stickers"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Front adhesive stickers"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Kiss cut stickers"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Laptop stickers"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Logo stickers"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Mug stickers"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Oval stickers"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Phone stickers"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Rectangle stickers"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Rounded corner stickers"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Square stickers"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer stickers"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Water bottle stickers"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Waterproof stickers"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Window stickers"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Fluorescent stickers"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Heavy duty stickers"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Glitter stickers"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Mirror gold stickers"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Mirror silver stickers"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Holographic stickers"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Sticker sheets"
            },
            "STICKER-WHITE-ALL": {
                "name": "White vinyl stickers"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biodegradable paper stickers"
            },
            "STICKER-CUSTOM-REFLECTIVE": {
                "name": "Reflective stickers"
            },
            "SAMPLE-PACK-DOG-STICKERS": {
                "name": "Dog Stickers"
            },
            "SAMPLE-PACK-CAT-STICKERS": {
                "name": "Cat Stickers"
            },
            "STICKER-WINDOW-CLING": {
                "name": "Window Clings"
            },
            "SAMPLE-STICKER-ECO-FRONTADHS": {
                "name": "Eco-friendly front adhesive sticker sample"
            },
            "SAMPLE-STICKER-STATIC-CLING": {
                "name": "Static cling samples"
            },
            "STICKER-ECO-FRONTADHS": {
                "name": "Eco-friendly front adhesive stickers"
            },
            "STICKER-STATIC-CLING": {
                "name": "Static Cling"
            },
            "STICKER-WALL": {
                "name": "Wall Stickers"
            },
            "STICKER-FLOOR": {
                "name": "Floor Stickers"
            },
            "SAMPLE-STICKER-FLOOR": {
                "name": "Floor sticker samples"
            },
            "SAMPLE-STICKER-WALL": {
                "name": "Wall sticker samples"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Customer Artwork",
            "PurposeCutFile": "Cut File",
            "PurposeDesignWorkingFile": "Design Working File",
            "PurposePrintReadyArtwork": "Print Ready Artwork",
            "PurposeProof": "Proof Bitmap",
            "PurposeProductSpecification": "Product Specification"
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albania",
            "DZ": "Algeria",
            "AS": "American Samoa",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarctica",
            "AG": "Antigua And Barbuda",
            "AR": "Argentina",
            "AM": "Armenia",
            "AW": "Aruba",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbaijan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Belarus",
            "BE": "Belgium",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivia",
            "BA": "Bosnia And Herzegovina",
            "BW": "Botswana",
            "BV": "Bouvet Island",
            "BR": "Brazil",
            "IO": "British Indian Ocean Territory",
            "BN": "Brunei Darussalam",
            "BG": "Bulgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Cambodia",
            "CM": "Cameroon",
            "CA": "Canada",
            "CV": "Cape Verde",
            "KY": "Cayman Islands",
            "CF": "Central African Republic",
            "TD": "Chad",
            "CL": "Chile",
            "CN": "China",
            "CX": "Christmas Island",
            "CC": "Cocos (keeling) Islands",
            "CO": "Colombia",
            "KM": "Comoros",
            "CG": "Congo",
            "CD": "Congo, The Democratic Republic Of The",
            "CK": "Cook Islands",
            "CR": "Costa Rica",
            "CI": "Cote D'ivoire",
            "HR": "Croatia",
            "CU": "Cuba",
            "CY": "Cyprus",
            "CZ": "Czech Republic",
            "DK": "Denmark",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "Dominican Republic",
            "TP": "East Timor",
            "EC": "Ecuador",
            "EG": "Egypt",
            "SV": "El Salvador",
            "GQ": "Equatorial Guinea",
            "ER": "Eritrea",
            "EE": "Estonia",
            "ET": "Ethiopia",
            "FK": "Falkland Islands (malvinas)",
            "FO": "Faroe Islands",
            "FJ": "Fiji",
            "FI": "Finland",
            "FR": "France",
            "GF": "French Guiana",
            "PF": "French Polynesia",
            "TF": "French Southern Territories",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Germany",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Greece",
            "GL": "Greenland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HM": "Heard Island And Mcdonald Islands",
            "VA": "Holy See (vatican City State)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungary",
            "IS": "Iceland",
            "IN": "India",
            "ID": "Indonesia",
            "IR": "Iran, Islamic Republic Of",
            "IQ": "Iraq",
            "IE": "Ireland",
            "IL": "Israel",
            "IT": "Italy",
            "JM": "Jamaica",
            "JP": "Japan",
            "JO": "Jordan",
            "KZ": "Kazakstan",
            "KE": "Kenya",
            "KI": "Kiribati",
            "KP": "Korea, Democratic People's Republic Of",
            "KR": "Korea, Republic Of",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kyrgyzstan",
            "LA": "Lao People's Democratic Republic",
            "LV": "Latvia",
            "LB": "Lebanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libyan Arab Jamahiriya",
            "LI": "Liechtenstein",
            "LT": "Lithuania",
            "LU": "Luxembourg",
            "MO": "Macau",
            "MK": "Macedonia, The Former Yugoslav Republic Of",
            "MG": "Madagascar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Maldives",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshall Islands",
            "MQ": "Martinique",
            "MR": "Mauritania",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Mexico",
            "FM": "Micronesia, Federated States Of",
            "MD": "Moldova, Republic Of",
            "MC": "Monaco",
            "MN": "Mongolia",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Morocco",
            "MZ": "Mozambique",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Netherlands",
            "AN": "Netherlands Antilles",
            "NC": "New Caledonia",
            "NZ": "New Zealand",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolk Island",
            "MP": "Northern Mariana Islands",
            "NO": "Norway",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Palestinian Territory, Occupied",
            "PA": "Panama",
            "PG": "Papua New Guinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Philippines",
            "PN": "Pitcairn",
            "PL": "Poland",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Qatar",
            "RE": "Reunion",
            "RO": "Romania",
            "RU": "Russian Federation",
            "RW": "Rwanda",
            "SH": "Saint Helena",
            "KN": "Saint Kitts And Nevis",
            "LC": "Saint Lucia",
            "PM": "Saint Pierre And Miquelon",
            "VC": "Saint Vincent And The Grenadines",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Sao Tome And Principe",
            "SA": "Saudi Arabia",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seychelles",
            "SL": "Sierra Leone",
            "SG": "Singapore",
            "SK": "Slovakia",
            "SI": "Slovenia",
            "SB": "Solomon Islands",
            "SO": "Somalia",
            "ZA": "South Africa",
            "GS": "South Georgia And The South Sandwich Islands",
            "ES": "Spain",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Suriname",
            "SJ": "Svalbard And Jan Mayen",
            "SZ": "Swaziland",
            "SE": "Sweden",
            "CH": "Switzerland",
            "SY": "Syrian Arab Republic",
            "TW": "Taiwan, Province Of China",
            "TJ": "Tajikistan",
            "TZ": "Tanzania, United Republic Of",
            "TH": "Thailand",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad And Tobago",
            "TN": "Tunisia",
            "TR": "Turkey",
            "TM": "Turkmenistan",
            "TC": "Turks And Caicos Islands",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukraine",
            "AE": "United Arab Emirates",
            "GB": "United Kingdom",
            "US": "United States",
            "UM": "United States Minor Outlying Islands",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Viet Nam",
            "VG": "Virgin Islands, British",
            "VI": "Virgin Islands, U.s.",
            "WF": "Wallis And Futuna",
            "EH": "Western Sahara",
            "YE": "Yemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    },
    "es": {
        "materials": {
            "brushed-silver": {
                "name": "Plateado cepillado"
            },
            "banner": {
                "name": "Bandera"
            },
            "eco-friendly-clear": {
                "name": "Transparente ecológico"
            },
            "eco-friendly": {
                "name": "Respetuoso con el medio ambiente"
            },
            "fluorescent-orange": {
                "name": "Naranja fluorescente"
            },
            "fluorescent-pink": {
                "name": "Rosa fluorescente"
            },
            "fluorescent-red": {
                "name": "Rojo fluorescente"
            },
            "fluorescent-yellow": {
                "name": "Amarillo fluorescente"
            },
            "front-adhesive": {
                "name": "Adhesivo frontal"
            },
            "glitter": {
                "name": "Purpurina"
            },
            "heavy-duty": {
                "name": "Alta resistencia"
            },
            "heavy-duty-clear": {
                "name": "Alta resistencia transparente"
            },
            "holographic": {
                "name": "Holográfico"
            },
            "mirror-gold": {
                "name": "Dorado cromado"
            },
            "mirror-silver": {
                "name": "Plateado cromado"
            },
            "paper-biodegradable": {
                "name": "Papel biodegradable"
            },
            "transfer-black": {
                "name": "Transferencia en negro"
            },
            "transfer-white": {
                "name": "Transferencia en blanco"
            },
            "vinyl-clear": {
                "name": "Vinilo transparente"
            },
            "vinyl-white": {
                "name": "Vinilo blanco"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "Banner de PVC"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Etiquetas de papel biodegradables en hojas"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Etiquetas troqueladas en hojas"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Etiquetas ecológicas transparentes en hojas"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Etiquetas ecológicas en hojas"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Etiquetas de purpurina en hojas"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Etiquetas holográficas en hojas"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Etiquetas plateadas cromadas en hojas"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Etiquetas de vinilo transparentes en hojas"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Etiquetas de vinilo blancas en hojas"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Paquete de muestra de pegatinas"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Muestras de pegatinas claras"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Muestras de pegatinas troqueladas"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Muestras de pegatinas ecológicas"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Muestras de pegatinas transparentes ecológicas"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Muestras de pegatinas adhesivas frontales"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Muestras de pegatinas semitroqueladas"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Muestras de pegatinas de transferencia"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Muestras de pegatinas fluorescentes"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Muestras de pegatinas de alta resistencia"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Muestras de pegatinas de purpurina"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Muestras de pegatinas doradas cromadas"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Muestras de pegatinas plateadas cromadas"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Muestras de pegatinas holográficas"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Muestras de pegatinas de papel biodegradable"
            },
            "SSK-CUSTOM": {
                "name": "Kit de pegatinas personalizadas para scooter eléctrico"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Pegatinas transparentes"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Pegatinas transparentes"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Pegatinas para bicicletas"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Pegatinas para coches"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Pegatinas circulares"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Pegatinas troqueladas"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Pegatinas ecológicas"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Pegatinas transparentes ecológicas"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Pegatinas adhesivas frontales"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Pegatinas semitroqueladas"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Pegatinas para portátiles"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Etiquetas para logotipos"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Pegatinas para tazas"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Pegatinas ovaladas"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Etiquetas engomadas del teléfono"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Pegatinas rectangulares"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Pegatinas de esquina redondeadas"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Pegatinas cuadradas"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Transferir pegatinas"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Etiquetas engomadas de la botella de agua"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Pegatinas impermeables"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Etiquetas engomadas de la ventana"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Pegatinas fluorescentes"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Adhesivos resistentes"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Pegatinas con purpurina"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Pegatinas espejo dorado"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Pegatinas plateadas espejo"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Pegatinas holográficas"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Hojas de pegatinas"
            },
            "STICKER-WHITE-ALL": {
                "name": "Adhesivos de vinilo blanco"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Pegatinas de papel biodegradables"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Obra de arte del cliente",
            "PurposeCutFile": "Cortar archivo",
            "PurposeDesignWorkingFile": "Diseño de archivo de trabajo",
            "PurposePrintReadyArtwork": "Ilustraciones listas para imprimir",
            "PurposeProof": "Mapa de bits de prueba",
            "PurposeProductSpecification": "Especificaciones del producto"
        },
        "countries": {
            "AF": "Afganistán",
            "AL": "Albania",
            "DZ": "Argelia",
            "AS": "Samoa Americana",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguila",
            "AQ": "Antártida",
            "AG": "Antigua y Barbuda",
            "AR": "Argentina",
            "AM": "Armenia",
            "AW": "Aruba",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbaiyán",
            "BS": "Bahamas",
            "BH": "Bahréin",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Bielorrusia",
            "BE": "Bélgica",
            "BZ": "Belice",
            "BJ": "Benin",
            "BM": "islas Bermudas",
            "BT": "Bután",
            "BO": "Bolivia",
            "BA": "Bosnia y Herzegovina",
            "BW": "Botswana",
            "BV": "Isla Bouvet",
            "BR": "Brasil",
            "IO": "Territorio Británico del Océano Índico",
            "BN": "Brunei Darussalam",
            "BG": "Bulgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Camboya",
            "CM": "Camerún",
            "CA": "Canadá",
            "CV": "Cabo Verde",
            "KY": "Islas Caimán",
            "CF": "República Centroafricana",
            "TD": "Chad",
            "CL": "Chile",
            "CN": "porcelana",
            "CX": "Isla de Navidad",
            "CC": "Islas Cocos (keeling)",
            "CO": "Colombia",
            "KM": "Comoras",
            "CG": "Congo",
            "CD": "Congo, República Democrática del",
            "CK": "Islas Cook",
            "CR": "Costa Rica",
            "CI": "Costa de Marfil",
            "HR": "Croacia",
            "CU": "Cuba",
            "CY": "Chipre",
            "CZ": "República Checa",
            "DK": "Dinamarca",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "República Dominicana",
            "TP": "Timor Oriental",
            "EC": "Ecuador",
            "EG": "Egipto",
            "SV": "El Salvador",
            "GQ": "Guinea Ecuatorial",
            "ER": "Eritrea",
            "EE": "Estonia",
            "ET": "Etiopía",
            "FK": "Islas Malvinas (Falkland Islands)",
            "FO": "Islas Faroe",
            "FJ": "Fiyi",
            "FI": "Finlandia",
            "FR": "Francia",
            "GF": "Guayana Francesa",
            "PF": "Polinesia francés",
            "TF": "Territorios Franceses del Sur",
            "GA": "Gabón",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Alemania",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Grecia",
            "GL": "Groenlandia",
            "GD": "Granada",
            "GP": "Guadalupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-bissau",
            "GY": "Guayana",
            "HT": "Haití",
            "HM": "Islas Heard y Mcdonald",
            "VA": "Santa Sede (Ciudad del Vaticano)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungría",
            "IS": "Islandia",
            "IN": "India",
            "ID": "Indonesia",
            "IR": "Irán (República Islámica de",
            "IQ": "Irak",
            "IE": "Irlanda",
            "IL": "Israel",
            "IT": "Italia",
            "JM": "Jamaica",
            "JP": "Japón",
            "JO": "Jordán",
            "KZ": "Kazajstán",
            "KE": "Kenia",
            "KI": "Kiribati",
            "KP": "República de Corea, Popular Democrática de",
            "KR": "Corea, república de",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kirguistán",
            "LA": "República Democrática Popular Lao",
            "LV": "Letonia",
            "LB": "Líbano",
            "LS": "Lesoto",
            "LR": "Liberia",
            "LY": "Jamahiriya Arabe Libia",
            "LI": "Liechtenstein",
            "LT": "Lituania",
            "LU": "Luxemburgo",
            "MO": "Macao",
            "MK": "Macedonia, la ex República Yugoslava de",
            "MG": "Madagascar",
            "MW": "Malawi",
            "MY": "Malasia",
            "MV": "Maldivas",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Islas Marshall",
            "MQ": "Martinica",
            "MR": "Mauritania",
            "MU": "Mauricio",
            "YT": "Mayotte",
            "MX": "México",
            "FM": "Micronesia, Estados Federados de",
            "MD": "Moldavia, República de",
            "MC": "Mónaco",
            "MN": "Mongolia",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Marruecos",
            "MZ": "Mozambique",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Países Bajos",
            "AN": "Antillas Holandesas",
            "NC": "Nueva Caledonia",
            "NZ": "Nueva Zelanda",
            "NI": "Nicaragua",
            "NE": "Níger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Isla Norfolk",
            "MP": "Islas Marianas del Norte",
            "NO": "Noruega",
            "OM": "Omán",
            "PK": "Pakistán",
            "PW": "Palau",
            "PS": "Territorio Palestino, Ocupado",
            "PA": "Panamá",
            "PG": "Papúa Nueva Guinea",
            "PY": "Paraguay",
            "PE": "Perú",
            "PH": "Filipinas",
            "PN": "Pitcairn",
            "PL": "Polonia",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Katar",
            "RE": "Reunión",
            "RO": "Rumania",
            "RU": "Federación Rusa",
            "RW": "Ruanda",
            "SH": "Santa elena",
            "KN": "San Cristóbal y Nieves",
            "LC": "Santa Lucía",
            "PM": "San Pedro y Miquelón",
            "VC": "San Vicente y las Granadinas",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Santo Tomé y Príncipe",
            "SA": "Arabia Saudita",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seychelles",
            "SL": "Sierra Leona",
            "SG": "Singapur",
            "SK": "Eslovaquia",
            "SI": "Eslovenia",
            "SB": "Islas Salomón",
            "SO": "Somalia",
            "ZA": "Sudáfrica",
            "GS": "Georgia del sur y las islas Sandwich del sur",
            "ES": "España",
            "LK": "Sri Lanka",
            "SD": "Sudán",
            "SR": "Surinam",
            "SJ": "Svalbard y Jan Mayen",
            "SZ": "Swazilandia",
            "SE": "Suecia",
            "CH": "Suiza",
            "SY": "República Árabe Siria",
            "TW": "Taiwan, provincia de China",
            "TJ": "Tayikistán",
            "TZ": "Tanzania, República Unida de",
            "TH": "Tailandia",
            "TG": "Para llevar",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad y Tobago",
            "TN": "Túnez",
            "TR": "pavo",
            "TM": "Turkmenistán",
            "TC": "Islas Turcas y Caicos",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ucrania",
            "AE": "Emiratos Árabes Unidos",
            "GB": "Reino Unido",
            "US": "Estados Unidos",
            "UM": "Islas menores alejadas de los Estados Unidos",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "VG": "Islas Vírgenes Británicas",
            "VI": "Islas Vírgenes, EE. UU.",
            "WF": "Wallis y Futuna",
            "EH": "Sahara Occidental",
            "YE": "Yemen",
            "ZM": "Zambia",
            "ZW": "Zimbabue"
        }
    },
    "it": {
        "materials": {
            "brushed-silver": {
                "name": "Argento spazzolato"
            },
            "banner": {
                "name": "Banner"
            },
            "eco-friendly-clear": {
                "name": "Trasparente ecologico"
            },
            "eco-friendly": {
                "name": "Ecologico"
            },
            "fluorescent-orange": {
                "name": "Arancio Fluorescente"
            },
            "fluorescent-pink": {
                "name": "Rosa fluorescente"
            },
            "fluorescent-red": {
                "name": "Rosso fluorescente"
            },
            "fluorescent-yellow": {
                "name": "Giallo fluorescente"
            },
            "front-adhesive": {
                "name": "Adesivo frontale"
            },
            "glitter": {
                "name": "scintillio"
            },
            "heavy-duty": {
                "name": "Robusto"
            },
            "heavy-duty-clear": {
                "name": "Cancella Heavy Duty"
            },
            "holographic": {
                "name": "Olografico"
            },
            "mirror-gold": {
                "name": "Specchio Oro"
            },
            "mirror-silver": {
                "name": "Specchio Argento"
            },
            "paper-biodegradable": {
                "name": "Carta biodegradabile"
            },
            "transfer-black": {
                "name": "Trasferimento nero"
            },
            "transfer-white": {
                "name": "Trasferimento bianco"
            },
            "vinyl-clear": {
                "name": "Vinile trasparente"
            },
            "vinyl-white": {
                "name": "Vinile bianco"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "Striscione in PVC"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Etichette in fogli di carta biodegradabile"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Etichette in fogli fustellati"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Etichette ecologiche trasparenti in fogli"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Etichette ecologiche in fogli"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Etichette in fogli glitter"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Etichette in fogli olografici"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Etichette in foglio d'argento a specchio"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Etichette trasparenti in fogli di vinile"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Etichette in foglio di vinile bianco"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Pacchetto campione adesivo"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Campioni di adesivi trasparenti"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Campioni di adesivi fustellati"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Campioni di adesivi ecologici"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Campioni di adesivi trasparenti ecologici"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Campioni di adesivi anteriori"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Campioni di adesivi tagliati a bacio"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Trasferire campioni di adesivi"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Campioni di adesivi fluorescenti"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Campioni di adesivi pesanti"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Campioni di adesivi glitterati"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Campioni di adesivi dorati a specchio"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Campioni di adesivi specchio argento"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Campioni di adesivi olografici"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Campioni di adesivi in carta biodegradabile"
            },
            "SSK-CUSTOM": {
                "name": "Kit adesivi per scooter elettrici personalizzati"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Adesivi trasparenti"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Adesivi trasparenti"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Adesivi per biciclette"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Adesivi per auto"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Adesivi cerchio"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Adesivi fustellati"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Adesivi ecologici"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Adesivi trasparenti ecologici"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Adesivi adesivi frontali"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Adesivi tagliati a bacio"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Adesivi per laptop"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Adesivi con logo"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Adesivi per tazze"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Adesivi ovali"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Adesivi per telefono"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Adesivi rettangolari"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Adesivi con angoli arrotondati"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Adesivi quadrati"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Adesivi trasferibili"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Adesivi per bottiglie d'acqua"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Adesivi impermeabili"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Adesivi per finestre"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Adesivi fluorescenti"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Adesivi pesanti"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Adesivi glitterati"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Adesivi dorati a specchio"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Adesivi argento specchio"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Adesivi olografici"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Fogli adesivi Sticker"
            },
            "STICKER-WHITE-ALL": {
                "name": "Adesivi in vinile bianco"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Adesivi in carta biodegradabile"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Opera d'arte del cliente Customer",
            "PurposeCutFile": "Taglia file",
            "PurposeDesignWorkingFile": "File di lavoro di progettazione",
            "PurposePrintReadyArtwork": "Opere d'arte pronte per la stampa",
            "PurposeProof": "Bitmap di prova",
            "PurposeProductSpecification": "Specifiche di prodotto"
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albania",
            "DZ": "Algeria",
            "AS": "Samoa americane",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antartide",
            "AG": "Antigua e Barbuda",
            "AR": "Argentina",
            "AM": "Armenia",
            "AW": "Aruba",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbaigian",
            "BS": "Bahamas",
            "BH": "Bahrein",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Bielorussia",
            "BE": "Belgio",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivia",
            "BA": "Bosnia Erzegovina",
            "BW": "Botswana",
            "BV": "Isola Bouvet",
            "BR": "Brasile",
            "IO": "Territorio britannico dell'Oceano Indiano",
            "BN": "Brunei Darussalam",
            "BG": "Bulgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Cambogia",
            "CM": "Camerun",
            "CA": "Canada",
            "CV": "capo Verde",
            "KY": "Isole Cayman",
            "CF": "Repubblica Centrafricana",
            "TD": "Chad",
            "CL": "Chile",
            "CN": "Cina",
            "CX": "Isola di Natale",
            "CC": "Isole Cocos (keeling)",
            "CO": "Colombia",
            "KM": "Comore",
            "CG": "Congo",
            "CD": "Congo, Repubblica Democratica del The",
            "CK": "Isole Cook",
            "CR": "Costa Rica",
            "CI": "Costa d'Avorio",
            "HR": "Croazia",
            "CU": "Cuba",
            "CY": "Cipro",
            "CZ": "Repubblica Ceca",
            "DK": "Danimarca",
            "DJ": "Gibuti",
            "DM": "dominica",
            "DO": "Repubblica Dominicana",
            "TP": "Timor Est",
            "EC": "Ecuador",
            "EG": "Egitto",
            "SV": "El Salvador",
            "GQ": "Guinea Equatoriale",
            "ER": "Eritrea",
            "EE": "Estonia",
            "ET": "Etiopia",
            "FK": "Isole Falkland (malvine)",
            "FO": "Isole Faroe",
            "FJ": "Figi",
            "FI": "Finlandia",
            "FR": "Francia",
            "GF": "Guiana francese",
            "PF": "Polinesia francese",
            "TF": "Territori della Francia del sud",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Germania",
            "GH": "Ghana",
            "GI": "Gibilterra",
            "GR": "Grecia",
            "GL": "Groenlandia",
            "GD": "Grenada",
            "GP": "Guadalupa",
            "GU": "Guami",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HM": "Heard Island e Mcdonald Islands",
            "VA": "Santa Sede (Stato della Città del Vaticano)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Ungheria",
            "IS": "Islanda",
            "IN": "India",
            "ID": "Indonesia",
            "IR": "Iran (Repubblica Islamica del",
            "IQ": "Iraq",
            "IE": "Irlanda",
            "IL": "Israele",
            "IT": "Italia",
            "JM": "Giamaica",
            "JP": "Giappone",
            "JO": "Giordania",
            "KZ": "Kazakistan",
            "KE": "Kenia",
            "KI": "Kiribati",
            "KP": "Corea, Repubblica Popolare Democratica di",
            "KR": "Corea, Repubblica di",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kirghizistan",
            "LA": "Repubblica Democratica Popolare del Laos",
            "LV": "Lettonia",
            "LB": "Libano",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Giamahiria Araba Libica",
            "LI": "Liechtenstein",
            "LT": "Lituania",
            "LU": "Lussemburgo",
            "MO": "Macau",
            "MK": "Macedonia, l'ex Repubblica jugoslava di",
            "MG": "Madagascar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Maldive",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Isole Marshall",
            "MQ": "Martinica",
            "MR": "Mauritania",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Messico",
            "FM": "Micronesia, Stati Federati di",
            "MD": "Moldavia, Repubblica di",
            "MC": "Monaco",
            "MN": "Mongolia",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Marocco",
            "MZ": "Mozambico",
            "MM": "Birmania",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Olanda",
            "AN": "Antille Olandesi",
            "NC": "Nuova Caledonia",
            "NZ": "Nuova Zelanda",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Isola Norfolk",
            "MP": "Isole Marianne settentrionali",
            "NO": "Norvegia",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Territorio palestinese, occupato",
            "PA": "Panama",
            "PG": "Papua Nuova Guinea",
            "PY": "Paraguay",
            "PE": "Perù",
            "PH": "Filippine",
            "PN": "Pitcairn",
            "PL": "Polonia",
            "PT": "Portogallo",
            "PR": "Porto Rico",
            "QA": "Qatar",
            "RE": "Riunione",
            "RO": "Romania",
            "RU": "Federazione Russa",
            "RW": "Ruanda",
            "SH": "Sant'Elena",
            "KN": "Saint Kitts e Nevis",
            "LC": "Santa Lucia",
            "PM": "Saint Pierre e Miquelon",
            "VC": "Saint Vincent e Grenadine",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Sao Tomé e Principe",
            "SA": "Arabia Saudita",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seychelles",
            "SL": "Sierra Leone",
            "SG": "Singapore",
            "SK": "Slovacchia",
            "SI": "Slovenia",
            "SB": "Isole Salomone",
            "SO": "Somalia",
            "ZA": "Sud Africa",
            "GS": "Georgia del Sud e Isole Sandwich Meridionali",
            "ES": "Spagna",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Suriname",
            "SJ": "Svalbard e Jan Mayen",
            "SZ": "Swaziland",
            "SE": "Svezia",
            "CH": "Svizzera",
            "SY": "Repubblica Araba Siriana",
            "TW": "Taiwan, provincia della Cina",
            "TJ": "Tagikistan",
            "TZ": "Tanzania, Repubblica Unita di",
            "TH": "Tailandia",
            "TG": "Andare",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad e Tobago",
            "TN": "Tunisia",
            "TR": "tacchino",
            "TM": "Turkmenistan",
            "TC": "Isole Turks e Caicos",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ucraina",
            "AE": "Emirati Arabi Uniti",
            "GB": "Regno Unito",
            "US": "stati Uniti",
            "UM": "Isole Minori Esterne degli Stati Uniti",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "VG": "Isole Vergini britanniche",
            "VI": "Isole Vergini, Stati Uniti",
            "WF": "Wallis e Futuna",
            "EH": "Sahara occidentale",
            "YE": "Yemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    },
    "pl": {
        "materials": {
            "brushed-silver": {
                "name": "Szczotkowane srebro"
            },
            "banner": {
                "name": "Transparent"
            },
            "eco-friendly-clear": {
                "name": "Ekologiczny Wyczyść"
            },
            "eco-friendly": {
                "name": "Ekologiczny"
            },
            "fluorescent-orange": {
                "name": "Fluorescencyjny Pomarańczowy"
            },
            "fluorescent-pink": {
                "name": "Fluorescencyjny Różowy"
            },
            "fluorescent-red": {
                "name": "Fluorescencyjny Czerwony"
            },
            "fluorescent-yellow": {
                "name": "Fluorescencyjny żółty"
            },
            "front-adhesive": {
                "name": "Klej z przodu"
            },
            "glitter": {
                "name": "Brokat"
            },
            "heavy-duty": {
                "name": "Wytrzymałe"
            },
            "heavy-duty-clear": {
                "name": "Wyczyść ciężki obowiązek"
            },
            "holographic": {
                "name": "Holograficzne"
            },
            "mirror-gold": {
                "name": "Lustrzane złoto"
            },
            "mirror-silver": {
                "name": "Lustro Srebrne"
            },
            "paper-biodegradable": {
                "name": "Papier biodegradowalny"
            },
            "transfer-black": {
                "name": "Przenieś czarny"
            },
            "transfer-white": {
                "name": "Przenieś biały"
            },
            "vinyl-clear": {
                "name": "Przezroczysty winyl"
            },
            "vinyl-white": {
                "name": "Biały winyl"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "Baner PCV"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Biodegradowalne etykiety papierowe w arkuszach"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Etykiety cięte na arkusze"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Ekologiczne przezroczyste etykiety arkuszowe"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Ekologiczne etykiety w arkuszach"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Etykiety z brokatem"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Etykiety holograficzne w arkuszach"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Lustrzane etykiety w kolorze srebrnym"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Przezroczyste etykiety winylowe"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Białe etykiety winylowe"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Pakiet próbek z naklejkami"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Próbki z przeźroczystymi naklejkami"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Próbki wycinanych naklejek"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Ekologiczne próbki naklejek"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Ekologiczne przezroczyste próbki naklejek"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Próbki przedniej naklejki samoprzylepnej"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Próbki naklejek wycinanych pocałunkiem"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Przenieś próbki naklejek"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Próbki naklejek fluorescencyjnych"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Próbki naklejek o dużej wytrzymałości"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Próbki naklejek z brokatem"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Próbki lustrzanych złotych naklejek"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Próbki lustrzanych srebrnych naklejek"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Holograficzne próbki naklejek"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biodegradowalne próbki naklejek papierowych"
            },
            "SSK-CUSTOM": {
                "name": "Niestandardowy zestaw naklejek na skuter elektryczny"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Przezroczyste naklejki"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Przezroczyste naklejki"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Naklejki rowerowe"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Naklejki samochodowe"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Okrągłe naklejki"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Wykrojone naklejki"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Ekologiczne naklejki"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Ekologiczne przezroczyste naklejki"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Przednie naklejki samoprzylepne"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Naklejki wycięte pocałunkiem"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Naklejki na laptopa"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Naklejki z logo"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Naklejki na kubki"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Naklejki owalne"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Naklejki na telefon"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Naklejki prostokątne"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Naklejki z zaokrąglonymi narożnikami"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Kwadratowe naklejki"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Naklejki transferowe"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Naklejki na butelki z wodą"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Wodoodporne naklejki"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Naklejki na okna"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Naklejki fluorescencyjne"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Naklejki o dużej wytrzymałości"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Brokatowe naklejki"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Lustrzane złote naklejki"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Lustrzane srebrne naklejki"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Naklejki holograficzne"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Arkusze naklejek"
            },
            "STICKER-WHITE-ALL": {
                "name": "Białe naklejki winylowe"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biodegradowalne naklejki papierowe"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Projekt klienta",
            "PurposeCutFile": "Wytnij plik",
            "PurposeDesignWorkingFile": "Projekt pliku roboczego",
            "PurposePrintReadyArtwork": "Grafika gotowa do druku",
            "PurposeProof": "Dowód bitmapowy",
            "PurposeProductSpecification": "Specyfikacja produktu"
        },
        "countries": {
            "AF": "Afganistan",
            "AL": "Albania",
            "DZ": "Algieria",
            "AS": "Samoa Amerykańskie",
            "AD": "Andora",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarktyda",
            "AG": "Antigua i Barbuda",
            "AR": "Argentyna",
            "AM": "Armenia",
            "AW": "Aruba",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbejdżan",
            "BS": "Bahamy",
            "BH": "Bahrajn",
            "BD": "Bangladesz",
            "BB": "Barbados",
            "BY": "Białoruś",
            "BE": "Belgia",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermudy",
            "BT": "Bhutan",
            "BO": "Boliwia",
            "BA": "Bośnia i Hercegowina",
            "BW": "Botswana",
            "BV": "Wyspa Bouveta",
            "BR": "Brazylia",
            "IO": "Brytyjskie Terytorium Oceanu Indyjskiego",
            "BN": "Brunei Darussalam",
            "BG": "Bułgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Kambodża",
            "CM": "Kamerun",
            "CA": "Kanada",
            "CV": "Wyspy Zielonego Przylądka",
            "KY": "Kajmany",
            "CF": "Republika Środkowoafrykańska",
            "TD": "Czad",
            "CL": "Chile",
            "CN": "Chiny",
            "CX": "Wyspa Bożego Narodzenia",
            "CC": "Wyspy Kokosowe (keeling)",
            "CO": "Kolumbia",
            "KM": "Komory",
            "CG": "Kongo",
            "CD": "Kongo, Demokratyczna Republika",
            "CK": "Wyspy Cooka",
            "CR": "Kostaryka",
            "CI": "Wybrzeże Kości Słoniowej",
            "HR": "Chorwacja",
            "CU": "Kuba",
            "CY": "Cypr",
            "CZ": "Republika Czeska",
            "DK": "Dania",
            "DJ": "Dżibuti",
            "DM": "Dominika",
            "DO": "Republika Dominikany",
            "TP": "Wschodni Timor",
            "EC": "Ekwador",
            "EG": "Egipt",
            "SV": "Salwador",
            "GQ": "Gwinea Równikowa",
            "ER": "Erytrea",
            "EE": "Estonia",
            "ET": "Etiopia",
            "FK": "Falklandy (malwiny)",
            "FO": "Wyspy Owcze",
            "FJ": "Fidżi",
            "FI": "Finlandia",
            "FR": "Francja",
            "GF": "Gujana Francuska",
            "PF": "Polinezja Francuska",
            "TF": "Francuskie Terytoria Południowe",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Gruzja",
            "DE": "Niemcy",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Grecja",
            "GL": "Grenlandia",
            "GD": "Grenada",
            "GP": "Gwadelupa",
            "GU": "Guam",
            "GT": "Gwatemala",
            "GN": "Gwinea",
            "GW": "Gwinea Bissau",
            "GY": "Gujana",
            "HT": "Haiti",
            "HM": "Wyspy Heard i Mcdonald",
            "VA": "Stolica Apostolska (Państwo Watykańskie)",
            "HN": "Honduras",
            "HK": "Hongkong",
            "HU": "Węgry",
            "IS": "Islandia",
            "IN": "Indie",
            "ID": "Indonezja",
            "IR": "Iran (Islamska Republika)",
            "IQ": "Irak",
            "IE": "Irlandia",
            "IL": "Izrael",
            "IT": "Włochy",
            "JM": "Jamajka",
            "JP": "Japonia",
            "JO": "Jordania",
            "KZ": "Kazachstan",
            "KE": "Kenia",
            "KI": "Kiribati",
            "KP": "Korea, Republika Ludowo-Demokratyczna",
            "KR": "Republika Korei",
            "KV": "Kosowo",
            "KW": "Kuwejt",
            "KG": "Kirgistan",
            "LA": "Laotańska Republika Ludowo-Demokratyczna",
            "LV": "Łotwa",
            "LB": "Liban",
            "LS": "Lesoto",
            "LR": "Liberia",
            "LY": "Libijska Arabska Dżamahirija",
            "LI": "Liechtenstein",
            "LT": "Litwa",
            "LU": "Luksemburg",
            "MO": "Makau",
            "MK": "Macedonia, była jugosłowiańska republika",
            "MG": "Madagaskar",
            "MW": "Malawi",
            "MY": "Malezja",
            "MV": "Malediwy",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Wyspy Marshalla",
            "MQ": "Martynika",
            "MR": "Mauretania",
            "MU": "Mauritius",
            "YT": "Majotta",
            "MX": "Meksyk",
            "FM": "Mikronezja, Sfederowane Stany",
            "MD": "Mołdawia, Republika",
            "MC": "Monako",
            "MN": "Mongolia",
            "MS": "Montserrat",
            "ME": "Czarnogóra",
            "MA": "Maroko",
            "MZ": "Mozambik",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Holandia",
            "AN": "Antyle Holenderskie",
            "NC": "Nowa Kaledonia",
            "NZ": "Nowa Zelandia",
            "NI": "Nikaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Wyspa Norfolk",
            "MP": "Mariany Północne",
            "NO": "Norwegia",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Teretorium Paleństynskie, Okupowane",
            "PA": "Panama",
            "PG": "Papua Nowa Gwinea",
            "PY": "Paragwaj",
            "PE": "Peru",
            "PH": "Filipiny",
            "PN": "Pitcairn",
            "PL": "Polska",
            "PT": "Portugalia",
            "PR": "Portoryko",
            "QA": "Katar",
            "RE": "Zjazd",
            "RO": "Rumunia",
            "RU": "Federacja Rosyjska",
            "RW": "Rwanda",
            "SH": "Święta Helena",
            "KN": "Saint Kitts i Nevis",
            "LC": "święta Lucia",
            "PM": "Saint-Pierre i Miquelon",
            "VC": "Saint Vincent i Grenadyny",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Wyspy Świętego Tomasza i Książęca",
            "SA": "Arabia Saudyjska",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seszele",
            "SL": "Sierra Leone",
            "SG": "Singapur",
            "SK": "Słowacja",
            "SI": "Słowenia",
            "SB": "Wyspy Salomona",
            "SO": "Somali",
            "ZA": "Afryka Południowa",
            "GS": "Georgia Południowa i Sandwich Południowy",
            "ES": "Hiszpania",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Surinam",
            "SJ": "Svalbard i Jan Mayen",
            "SZ": "Suazi",
            "SE": "Szwecja",
            "CH": "Szwajcaria",
            "SY": "Republika Syryjsko-Arabska",
            "TW": "Tajwan, prowincja Chin",
            "TJ": "Tadżykistan",
            "TZ": "Tanzania, Zjednoczona Republika",
            "TH": "Tajlandia",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trynidad i Tobago",
            "TN": "Tunezja",
            "TR": "Turkey",
            "TM": "Turkmenia",
            "TC": "Wyspy Turks i Caicos",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukraina",
            "AE": "Zjednoczone Emiraty Arabskie",
            "GB": "Zjednoczone Królestwo",
            "US": "Stany Zjednoczone",
            "UM": "Stany Zjednoczone Dalekie Wyspy Mniejsze",
            "UY": "Urugwaj",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Wenezuela",
            "VN": "Wietnam",
            "VG": "Wyspy Dziewicze, Brytyjskie",
            "VI": "Wyspy Dziewicze Stanów Zjednoczonych",
            "WF": "Wallis i Futuna",
            "EH": "Sahara Zachodnia",
            "YE": "Jemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    },
    "pt": {
        "materials": {
            "brushed-silver": {
                "name": "Prata Escovada"
            },
            "banner": {
                "name": "Bandeira"
            },
            "eco-friendly-clear": {
                "name": "Transparente ecológico"
            },
            "eco-friendly": {
                "name": "Ecológico"
            },
            "fluorescent-orange": {
                "name": "Laranja fluorescente"
            },
            "fluorescent-pink": {
                "name": "Rosa fluorescente"
            },
            "fluorescent-red": {
                "name": "Vermelho fluorescente"
            },
            "fluorescent-yellow": {
                "name": "Amarelo Fluorescente"
            },
            "front-adhesive": {
                "name": "Adesivo Frontal"
            },
            "glitter": {
                "name": "Brilho"
            },
            "heavy-duty": {
                "name": "Trabalho pesado"
            },
            "heavy-duty-clear": {
                "name": "Limpar serviço pesado"
            },
            "holographic": {
                "name": "Holográfico"
            },
            "mirror-gold": {
                "name": "Espelho Dourado"
            },
            "mirror-silver": {
                "name": "Espelho De Prata"
            },
            "paper-biodegradable": {
                "name": "Papel Biodegradável"
            },
            "transfer-black": {
                "name": "Transfer Black"
            },
            "transfer-white": {
                "name": "Transfer White"
            },
            "vinyl-clear": {
                "name": "Vinil transparente"
            },
            "vinyl-white": {
                "name": "Vinil branco"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "Banner de PVC"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Etiquetas de folhas de papel biodegradáveis"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Etiquetas de folhas cortadas"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Etiquetas transparentes ecológicas para folhas"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Etiquetas de folhas ecológicas"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Etiquetas de folha de brilho"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Rótulos de folha holográfica"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Etiquetas de folha de prata espelhada"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Etiquetas de folha de vinil transparente"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Etiquetas de folha de vinil branco"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Pacote de amostra de adesivos"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Amostras de adesivos transparentes"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Amostras de adesivos cortados"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Amostras de adesivos ecológicos"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Amostras de adesivos transparentes ecológicos"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Amostras de adesivos adesivos frontais"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Amostras de adesivos Kiss cut"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Transferir amostras de adesivos"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Amostras de adesivos fluorescentes"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Amostras de adesivos resistentes"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Amostras de adesivos brilhantes"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Amostras de adesivos dourados em espelho"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Amostras de adesivos de prata espelhada"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Amostras de adesivos holográficos"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Amostras de adesivos de papel biodegradáveis"
            },
            "SSK-CUSTOM": {
                "name": "Kit de adesivos de scooter elétrica personalizado"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Adesivos claros"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Adesivos transparentes"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Adesivos de bicicleta"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Adesivos de carro"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Autocolantes circulares"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Adesivos cortados"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Adesivos ecológicos"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Adesivos transparentes ecológicos"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Adesivos adesivos frontais"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Adesivos de corte de beijo"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Adesivos de laptop"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Adesivos de logotipo"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Adesivos de canecas"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Autocolantes ovais"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Adesivos de telefone"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Adesivos retangulares"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Adesivos de canto arredondado"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Adesivos quadrados"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Adesivos de transferência"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Adesivos de garrafa de água"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Adesivos impermeáveis"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Adesivos de janela"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Adesivos fluorescentes"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Adesivos resistentes"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Adesivos de brilho"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Adesivos de espelho dourado"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Adesivos de espelho prateado"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Adesivos holográficos"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Folhas de adesivos"
            },
            "STICKER-WHITE-ALL": {
                "name": "Adesivos de vinil branco"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Adesivos de papel biodegradável"
            },
            "STICKER-CUSTOM-REFLECTIVE": {
                "name": "Adesivos reflexivos"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Arte do cliente",
            "PurposeCutFile": "Arquivo de Corte",
            "PurposeDesignWorkingFile": "Arquivo de Trabalho de Projeto",
            "PurposePrintReadyArtwork": "Arte pronta para impressão",
            "PurposeProof": "Bitmap de prova",
            "PurposeProductSpecification": "Especificação do produto"
        },
        "countries": {
            "AF": "Afeganistão",
            "AL": "Albânia",
            "DZ": "Argélia",
            "AS": "Samoa Americana",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antártica",
            "AG": "Antigua e Barbuda",
            "AR": "Argentina",
            "AM": "Armênia",
            "AW": "Aruba",
            "AU": "Austrália",
            "AT": "Áustria",
            "AZ": "Azerbaijão",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Bielo-Rússia",
            "BE": "Bélgica",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermudas",
            "BT": "Butão",
            "BO": "Bolívia",
            "BA": "Bósnia e Herzegovina",
            "BW": "Botswana",
            "BV": "Ilha Bouvet",
            "BR": "Brasil",
            "IO": "Território Britânico do Oceano Índico",
            "BN": "Brunei Darussalam",
            "BG": "Bulgária",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Camboja",
            "CM": "Camarões",
            "CA": "Canadá",
            "CV": "cabo Verde",
            "KY": "Ilhas Cayman",
            "CF": "República Centro-Africana",
            "TD": "Chade",
            "CL": "Chile",
            "CN": "China",
            "CX": "Ilha do Natal",
            "CC": "Ilhas Cocos (keeling)",
            "CO": "Colômbia",
            "KM": "Comores",
            "CG": "Congo",
            "CD": "Congo, República Democrática do",
            "CK": "Ilhas Cook",
            "CR": "Costa Rica",
            "CI": "Costa do Marfim",
            "HR": "Croácia",
            "CU": "Cuba",
            "CY": "Chipre",
            "CZ": "República Checa",
            "DK": "Dinamarca",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "República Dominicana",
            "TP": "Timor Leste",
            "EC": "Equador",
            "EG": "Egito",
            "SV": "El Salvador",
            "GQ": "Guiné Equatorial",
            "ER": "Eritreia",
            "EE": "Estônia",
            "ET": "Etiópia",
            "FK": "Ilhas Falkland (malvinas)",
            "FO": "ilhas Faroe",
            "FJ": "Fiji",
            "FI": "Finlândia",
            "FR": "França",
            "GF": "Guiana Francesa",
            "PF": "Polinésia Francesa",
            "TF": "Territórios Franceses do Sul",
            "GA": "Gabão",
            "GM": "Gâmbia",
            "GE": "Georgia",
            "DE": "Alemanha",
            "GH": "Gana",
            "GI": "Gibraltar",
            "GR": "Grécia",
            "GL": "Groenlândia",
            "GD": "Grenada",
            "GP": "Guadalupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guiné",
            "GW": "Guiné-bissau",
            "GY": "Guiana",
            "HT": "Haiti",
            "HM": "Ilha Heard e Ilhas Mcdonald",
            "VA": "Santa Sé (cidade-estado do Vaticano)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungria",
            "IS": "Islândia",
            "IN": "Índia",
            "ID": "Indonésia",
            "IR": "Irã (Republic Islâmica do Irã",
            "IQ": "Iraque",
            "IE": "Irlanda",
            "IL": "Israel",
            "IT": "Itália",
            "JM": "Jamaica",
            "JP": "Japão",
            "JO": "Jordânia",
            "KZ": "Cazaquistão",
            "KE": "Quênia",
            "KI": "Kiribati",
            "KP": "Coréia, República Popular Democrática da",
            "KR": "Republica da Coréia",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Quirguistão",
            "LA": "República Democrática Popular do Laos",
            "LV": "Letônia",
            "LB": "Líbano",
            "LS": "Lesoto",
            "LR": "Libéria",
            "LY": "Jamahiriya Árabe da Líbia",
            "LI": "Liechtenstein",
            "LT": "Lituânia",
            "LU": "Luxemburgo",
            "MO": "Macau",
            "MK": "Macedônia, Antiga República Iugoslava da",
            "MG": "Madagáscar",
            "MW": "Malawi",
            "MY": "Malásia",
            "MV": "Maldivas",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Ilhas Marshall",
            "MQ": "Martinica",
            "MR": "Mauritânia",
            "MU": "Maurício",
            "YT": "Mayotte",
            "MX": "México",
            "FM": "Micronésia, Estados Federados da",
            "MD": "Moldávia, República da",
            "MC": "Mônaco",
            "MN": "Mongólia",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Marrocos",
            "MZ": "Moçambique",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Países Baixos",
            "AN": "Antilhas Holandesas",
            "NC": "Nova Caledônia",
            "NZ": "Nova Zelândia",
            "NI": "Nicarágua",
            "NE": "Níger",
            "NG": "Nigéria",
            "NU": "Niue",
            "NF": "Ilha Norfolk",
            "MP": "Ilhas Marianas do Norte",
            "NO": "Noruega",
            "OM": "Omã",
            "PK": "Paquistão",
            "PW": "Palau",
            "PS": "Território Palestino, Ocupado",
            "PA": "Panamá",
            "PG": "Papua Nova Guiné",
            "PY": "Paraguai",
            "PE": "Peru",
            "PH": "Filipinas",
            "PN": "Pitcairn",
            "PL": "Polônia",
            "PT": "Portugal",
            "PR": "Porto Rico",
            "QA": "Catar",
            "RE": "Reunião",
            "RO": "Romênia",
            "RU": "Federação Russa",
            "RW": "Ruanda",
            "SH": "Santa Helena",
            "KN": "São Cristóvão e Neves",
            "LC": "Santa Lúcia",
            "PM": "São Pedro e Miquelão",
            "VC": "São Vicente e Granadinas",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "São Tomé e Príncipe",
            "SA": "Arábia Saudita",
            "SN": "Senegal",
            "RS": "Sérvia",
            "SC": "Seychelles",
            "SL": "Serra Leoa",
            "SG": "Cingapura",
            "SK": "Eslováquia",
            "SI": "Eslovênia",
            "SB": "Ilhas Salomão",
            "SO": "Somália",
            "ZA": "África do Sul",
            "GS": "Geórgia do Sul e Ilhas Sandwich do Sul",
            "ES": "Espanha",
            "LK": "Sri Lanka",
            "SD": "Sudão",
            "SR": "Suriname",
            "SJ": "Svalbard e Jan Mayen",
            "SZ": "Suazilândia",
            "SE": "Suécia",
            "CH": "Suíça",
            "SY": "República Árabe da Síria",
            "TW": "Taiwan, província da China",
            "TJ": "Tajiquistão",
            "TZ": "Tanzânia, República Unida da",
            "TH": "Tailândia",
            "TG": "Ir",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad e Tobago",
            "TN": "Tunísia",
            "TR": "Peru",
            "TM": "Turcomenistão",
            "TC": "Ilhas Turcas e Caicos",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ucrânia",
            "AE": "Emirados Árabes Unidos",
            "GB": "Reino Unido",
            "US": "Estados Unidos",
            "UM": "Ilhas Menores Distantes dos Estados Unidos",
            "UY": "Uruguai",
            "UZ": "Uzbequistão",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Viet Nam",
            "VG": "Ilhas Virgens Britânicas",
            "VI": "Ilhas Virgens, EUA",
            "WF": "Wallis e Futuna",
            "EH": "Saara Ocidental",
            "YE": "Iémen",
            "ZM": "Zâmbia",
            "ZW": "Zimbábue"
        }
    },
    "sv": {
        "materials": {
            "brushed-silver": {
                "name": "Borstad silber"
            },
            "banner": {
                "name": "Baner"
            },
            "eco-friendly-clear": {
                "name": "Miljötransparent Klar"
            },
            "eco-friendly": {
                "name": "Miljövänlig"
            },
            "fluorescent-orange": {
                "name": "Fluorescerande apelsin"
            },
            "fluorescent-pink": {
                "name": "Fluorescerande rosa"
            },
            "fluorescent-red": {
                "name": "Fluorescerande röd"
            },
            "fluorescent-yellow": {
                "name": "Fluorescerande gul"
            },
            "front-adhesive": {
                "name": "Frontlim"
            },
            "glitter": {
                "name": "Glitter"
            },
            "heavy-duty": {
                "name": "Heavy Duty"
            },
            "heavy-duty-clear": {
                "name": "Clear Heavy Duty"
            },
            "holographic": {
                "name": "Holografisk"
            },
            "mirror-gold": {
                "name": "Spegelguld"
            },
            "mirror-silver": {
                "name": "Spegel Silver"
            },
            "paper-biodegradable": {
                "name": "Biologiskt nedbrytbart papper"
            },
            "transfer-black": {
                "name": "Överför svart"
            },
            "transfer-white": {
                "name": "Överför vit"
            },
            "vinyl-clear": {
                "name": "Transparent vinyl"
            },
            "vinyl-white": {
                "name": "Vit vinyl"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "PVC-banderoll"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Biologiskt nedbrytbara etiketter på pappersark"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Stansade etiketter"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Miljövänliga etiketter för tydliga ark"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Miljövänliga etiketter"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Etiketter för glitterark"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Holografiska etiketter"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Etiketter i spegel silverark"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Rensa etiketter på vinylark"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Vita vinylarketiketter"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Klistermärke provpaket"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Rensa klistermärkeprover"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Stansade klistermärkeprover"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Miljövänliga klistermärkeprover"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Miljövänliga klara stickprover"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Prov på självhäftande klistermärke"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Kiss cut klistermärke prover"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Överför klistermärkeprover"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Fluorescerande stickprover"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Prover för kraftiga klistermärken"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Glitter klistermärke prover"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Spegel guld klistermärke prover"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Spegel silver klistermärke prover"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Holografiska klistermärkeprover"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biologiskt nedbrytbara pappersmärken"
            },
            "SSK-CUSTOM": {
                "name": "Anpassad klistermärke för elektrisk skoter"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Rensa klistermärken"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Transparenta klistermärken"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Cykelklistermärken"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Bil klistermärken"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Cirkel klistermärken"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Stansade klistermärken"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Miljövänliga klistermärken"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Miljövänliga klistermärken"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Klistermärken på framsidan"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Kiss cut klistermärken"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Laptop klistermärken"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Logo klistermärken"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Mugg klistermärken"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Ovala klistermärken"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Telefon klistermärken"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Rektangel klistermärken"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Rundade hörnklistermärken"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Fyrkantiga klistermärken"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Överför klistermärken"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Klistermärken för vattenflaskor"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Vattentäta klistermärken"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Fönster klistermärken"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Fluorescerande klistermärken"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Kraftiga klistermärken"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Glitter klistermärken"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Spegel guld klistermärken"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Spegel silver klistermärken"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Holografiska klistermärken"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Klistermärke ark"
            },
            "STICKER-WHITE-ALL": {
                "name": "Vita vinylklistermärken"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Biologiskt nedbrytbara pappersdekaler"
            },
            "STICKER-CUSTOM-REFLECTIVE": {
                "name": "Reflekterande klistermärken"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Kundens konstverk",
            "PurposeCutFile": "Klipp av fil",
            "PurposeDesignWorkingFile": "Design arbetsfil",
            "PurposePrintReadyArtwork": "Skriv ut färdiga konstverk",
            "PurposeProof": "Bevisbitmapp",
            "PurposeProductSpecification": "Produktspecifikation"
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albanien",
            "DZ": "Algeriet",
            "AS": "Amerikanska Samoa",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarktis",
            "AG": "Antigua och Barbuda",
            "AR": "Argentina",
            "AM": "Armenien",
            "AW": "Aruba",
            "AU": "Australien",
            "AT": "Österrike",
            "AZ": "Azerbajdzjan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Vitryssland",
            "BE": "Belgien",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivia",
            "BA": "Bosnien och Hercegovina",
            "BW": "Botswana",
            "BV": "Bouvet Island",
            "BR": "Brasilien",
            "IO": "Brittiska territoriet i Indiska oceanen",
            "BN": "Brunei Darussalam",
            "BG": "Bulgarien",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Kambodja",
            "CM": "Kamerun",
            "CA": "Kanada",
            "CV": "Cap Verde",
            "KY": "Caymanöarna",
            "CF": "Centralafrikanska republiken",
            "TD": "Tchad",
            "CL": "Chile",
            "CN": "Kina",
            "CX": "Julön",
            "CC": "Cocos (kölande) öar",
            "CO": "Colombia",
            "KM": "Komorerna",
            "CG": "Kongo",
            "CD": "Kongo, Demokratiska republiken",
            "CK": "Cooköarna",
            "CR": "Costa Rica",
            "CI": "Elfenbenskusten",
            "HR": "Kroatien",
            "CU": "Kuba",
            "CY": "Cypern",
            "CZ": "Tjeckien",
            "DK": "Danmark",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "Dominikanska republiken",
            "TP": "Östtimor",
            "EC": "Ecuador",
            "EG": "Egypten",
            "SV": "El Salvador",
            "GQ": "Ekvatorialguinea",
            "ER": "Eritrea",
            "EE": "Estland",
            "ET": "Etiopien",
            "FK": "Falklandsöarna (malvinas)",
            "FO": "Färöarna",
            "FJ": "Fiji",
            "FI": "Finland",
            "FR": "Frankrike",
            "GF": "Franska Guyana",
            "PF": "Franska Polynesien",
            "TF": "Franska södra territorierna",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Georgien",
            "DE": "Tyskland",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Grekland",
            "GL": "Grönland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HM": "Heard Island och Mcdonald Islands",
            "VA": "Holy See (Vatikanstaten)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Ungern",
            "IS": "Island",
            "IN": "Indien",
            "ID": "Indonesien",
            "IR": "Iran, Islamiska republiken",
            "IQ": "Irak",
            "IE": "Irland",
            "IL": "Israel",
            "IT": "Italien",
            "JM": "Jamaica",
            "JP": "Japan",
            "JO": "Jordanien",
            "KZ": "Kazakstan",
            "KE": "Kenya",
            "KI": "Kiribati",
            "KP": "Korea, Demokratiska folkrepubliken",
            "KR": "Korea, Republiken av",
            "KV": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kirgizistan",
            "LA": "Demokratiska folkrepubliken Laos",
            "LV": "Lettland",
            "LB": "Libanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libyska arabiska Jamahiriya",
            "LI": "Liechtenstein",
            "LT": "Litauen",
            "LU": "Luxemburg",
            "MO": "Macau",
            "MK": "Makedonien, fd jugoslaviska republiken",
            "MG": "Madagaskar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Maldiverna",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshallöarna",
            "MQ": "Martinique",
            "MR": "Mauretanien",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Mexiko",
            "FM": "Mikronesien, federerade staterna i",
            "MD": "Moldavien, Republiken",
            "MC": "Monaco",
            "MN": "mongoliet",
            "MS": "Montserrat",
            "ME": "Montenegro",
            "MA": "Marocko",
            "MZ": "Moçambique",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Nederländerna",
            "AN": "Nederländska Antillerna",
            "NC": "Nya Kaledonien",
            "NZ": "Nya Zeeland",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolk Island",
            "MP": "Norra Marianeröarna",
            "NO": "Norge",
            "OM": "oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Palestinska territoriet, ockuperat",
            "PA": "Panama",
            "PG": "Papua Nya Guinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Filippinerna",
            "PN": "Pitcairn",
            "PL": "Polen",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Qatar",
            "RE": "Återförening",
            "RO": "Rumänien",
            "RU": "Ryska Federationen",
            "RW": "Rwanda",
            "SH": "Saint Helena",
            "KN": "Saint Kitts och Nevis",
            "LC": "Saint Lucia",
            "PM": "Saint Pierre och Miquelon",
            "VC": "Saint Vincent och Grenadinerna",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Sao Tomé och Principe",
            "SA": "Saudiarabien",
            "SN": "Senegal",
            "RS": "Serbien",
            "SC": "Seychellerna",
            "SL": "Sierra Leone",
            "SG": "Singapore",
            "SK": "Slovakien",
            "SI": "Slovenien",
            "SB": "Salomonöarna",
            "SO": "Somalia",
            "ZA": "Sydafrika",
            "GS": "Södra Georgien och södra Sandwichöarna",
            "ES": "Spanien",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Surinam",
            "SJ": "Svalbard och Jan Mayen",
            "SZ": "Swaziland",
            "SE": "Sverige",
            "CH": "Schweiz",
            "SY": "Syrien, Arabiska republiken",
            "TW": "Taiwan, provinsen Kina",
            "TJ": "Tadzjikistan",
            "TZ": "Tanzania, Förenade republiken",
            "TH": "Thailand",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad och Tobago",
            "TN": "Tunisien",
            "TR": "Kalkon",
            "TM": "Turkmenistan",
            "TC": "Turks- och Caicosöarna",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukraina",
            "AE": "Förenade arabemiraten",
            "GB": "Storbritannien",
            "US": "Förenta staterna",
            "UM": "USA: s mindre avlägsna öar",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "VG": "Jungfruöarna, brittiska",
            "VI": "Jungfruöarna, U.s.",
            "WF": "Wallis och Futuna",
            "EH": "Västra Sahara",
            "YE": "Jemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    },
    "tr": {
        "materials": {
            "brushed-silver": {
                "name": "fırçalanmış gümüş"
            },
            "banner": {
                "name": "Afiş"
            },
            "eco-friendly-clear": {
                "name": "Çevre dostu şeffaf"
            },
            "eco-friendly": {
                "name": "çevre dostu"
            },
            "fluorescent-orange": {
                "name": "Neon Turuncu"
            },
            "fluorescent-pink": {
                "name": "Neon Pembe"
            },
            "fluorescent-red": {
                "name": "Neon Kırmızı"
            },
            "fluorescent-yellow": {
                "name": "Neon Sarı"
            },
            "front-adhesive": {
                "name": "Önü yapışkanlı"
            },
            "glitter": {
                "name": "Parıltı"
            },
            "heavy-duty": {
                "name": "Güçlü"
            },
            "heavy-duty-clear": {
                "name": "Şeffaf güçlü"
            },
            "holographic": {
                "name": "holografik"
            },
            "mirror-gold": {
                "name": "aynalı altın"
            },
            "mirror-silver": {
                "name": "aynalı gümüş"
            },
            "paper-biodegradable": {
                "name": "Doğada çözünebilir kağıt"
            },
            "transfer-black": {
                "name": "Siyah Transfer"
            },
            "transfer-white": {
                "name": "Beyaz Transfer"
            },
            "vinyl-clear": {
                "name": "Şeffaf folyo"
            },
            "vinyl-white": {
                "name": "Beyaz Folyo"
            }
        },
        "products": {
            "BANNER-WHITE-PVC": {
                "name": "PVC Afiş"
            },
            "LABELS-SHEETS-BIODEGRADABLE": {
                "name": "Doğada çözünebilir kağıt levha etiketleri"
            },
            "LABELS-SHEETS-DIE-CUT": {
                "name": "Kalıp kesim levha etiketleri"
            },
            "LABELS-SHEETS-ECOFRIENDLYCLEAR": {
                "name": "Çevre dostu şeffaf levha etiketleri"
            },
            "LABELS-SHEETS-ECOFRIENDLYWHITE": {
                "name": "Çevre dostu etiketler"
            },
            "LABELS-SHEETS-GLITTER": {
                "name": "Parlak etiketler"
            },
            "LABELS-SHEETS-HOLOGRAPHIC": {
                "name": "Holografik etiketler"
            },
            "LABELS-SHEETS-MIRROR-SILVER": {
                "name": "Aynalı gümüş levha etiketleri"
            },
            "LABELS-SHEETS-VINYL-CLEAR": {
                "name": "Şeffaf folyo etiketleri"
            },
            "LABELS-SHEETS-VINYL-WHITE": {
                "name": "Beyaz folyo etiketleri"
            },
            "SAMPLE-PACK-STICKER-STD": {
                "name": "Örnek etiket paketi"
            },
            "SAMPLE-STICKER-CLEARGLOSS-ALL": {
                "name": "Şeffaf çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-DIE": {
                "name": "Kalıp kesim çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Çevre dostu çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Çevre dostu şeffaf çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Önü yapışkanlı çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-KISS": {
                "name": "Tabaka kesim çıkartma örnekleri"
            },
            "SAMPLE-STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer çıkartma örnekleri"
            },
            "SAMPLE-STICKER-FLUORESCENT-ALL": {
                "name": "Neon çıkartma örnekleri"
            },
            "SAMPLE-STICKER-HEAVYDUTY-ALL": {
                "name": "Güçlü çıkartma örnekleri"
            },
            "SAMPLE-STICKER-HOLOGRAM-ALL": {
                "name": "Parıltılı çıkartma örnekleri"
            },
            "SAMPLE-STICKER-MIRROR-GOLD": {
                "name": "Aynalı altın çıkartma örnekleri"
            },
            "SAMPLE-STICKER-MIRROR-SILVER": {
                "name": "Aynalı gümüş çıkartma örnekleri"
            },
            "SAMPLE-STICKER-PEARLESCENT-ALL": {
                "name": "Holografik çıkartma örnekleri"
            },
            "SAMPLE-STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Doğada çözünebilir kağıt etiket örnekleri"
            },
            "SSK-CUSTOM": {
                "name": "Kişiye özel elektrikli scooter çıkartma seti"
            },
            "STICKER-CLEARGLOSS-ALL": {
                "name": "Şeffaf çıkartmalar"
            },
            "STICKER-CLEARGLOSS-TRANSPARENT": {
                "name": "Şeffaf çıkartmalar"
            },
            "STICKER-CUSTOM-BICYCLE": {
                "name": "Bisiklet çıkartmaları"
            },
            "STICKER-CUSTOM-CAR": {
                "name": "Araba çıkartmaları"
            },
            "STICKER-CUSTOM-CIRCULAR": {
                "name": "Daire şeklinde çıkartmalar"
            },
            "STICKER-CUSTOM-DIE": {
                "name": "Kalıp kesim çıkartmalar"
            },
            "STICKER-CUSTOM-ECOFRIENDLY": {
                "name": "Çevre dostu çıkartmalar"
            },
            "STICKER-CUSTOM-ECOFRIENDLYCLEAR": {
                "name": "Çevre dostu şeffaf çıkartmalar"
            },
            "STICKER-CUSTOM-FRONTADHESIVE": {
                "name": "Önü yapışkanlı çıkartmalar"
            },
            "STICKER-CUSTOM-KISS": {
                "name": "Tabaka kesim çıkartmalar"
            },
            "STICKER-CUSTOM-LAPTOP": {
                "name": "Laptop çıkartmaları"
            },
            "STICKER-CUSTOM-LOGO": {
                "name": "Logo çıkartmaları"
            },
            "STICKER-CUSTOM-MUG": {
                "name": "Kupa çıkartmaları"
            },
            "STICKER-CUSTOM-OVAL": {
                "name": "Oval çıkartmalar"
            },
            "STICKER-CUSTOM-PHONE": {
                "name": "Telefon çıkartmaları"
            },
            "STICKER-CUSTOM-RECTANGULAR": {
                "name": "Dikdörtgen çıkartmalar"
            },
            "STICKER-CUSTOM-ROUNDED": {
                "name": "Köşeleri yuvarlak çıkartmalar"
            },
            "STICKER-CUSTOM-SQUARE": {
                "name": "Kare çıkartmalar"
            },
            "STICKER-CUSTOM-TRANSFER": {
                "name": "Transfer çıkartmalar"
            },
            "STICKER-CUSTOM-WATERBOTTLE": {
                "name": "Su şişesi çıkartmaları"
            },
            "STICKER-CUSTOM-WATERPROOF": {
                "name": "Su geçirmez çıkartmalar"
            },
            "STICKER-CUSTOM-WINDOW": {
                "name": "Pencere çıkartmaları"
            },
            "STICKER-FLUORESCENT-ALL": {
                "name": "Neon çıkartmalar"
            },
            "STICKER-HEAVYDUTY-ALL": {
                "name": "Güçlü çıkartmalar"
            },
            "STICKER-HOLOGRAM-ALL": {
                "name": "Parıltılı çıkartmalar"
            },
            "STICKER-MIRROR-GOLD": {
                "name": "Aynalı altın çıkartmalar"
            },
            "STICKER-MIRROR-SILVER": {
                "name": "Aynalı gümüş çıkartmalar"
            },
            "STICKER-PEARLESCENT-ALL": {
                "name": "Holografik çıkartmalar"
            },
            "STICKER-SHEETS-ALL": {
                "name": "Çıkartma tabakaları"
            },
            "STICKER-WHITE-ALL": {
                "name": "Beyaz folyo çıkartmalar"
            },
            "STICKERS-CUSTOM-BIODEGRADABLE": {
                "name": "Doğada çözünebilen kağıt çıkartmalar"
            },
            "STICKER-CUSTOM-REFLECTIVE": {
                "name": "Reflektif/yansıtıcı çıkartmalar"
            }
        },
        "FilePurpose": {
            "PurposeCustomerArtwork": "Müşteri görseli",
            "PurposeCutFile": "Dosyayı Kes",
            "PurposeDesignWorkingFile": "Tasarım Çalışma Dosyası",
            "PurposePrintReadyArtwork": "Baskıya Hazır Görseller",
            "PurposeProof": "Taslak görseli",
            "PurposeProductSpecification": "Ürün özellikleri"
        },
        "countries": {
            "AF": "Afganistan",
            "AL": "Arnavutluk",
            "DZ": "Cezayir",
            "AS": "Amerikan Samoası",
            "AD": "Andora",
            "AO": "Angola",
            "AI": "Anguilla",
            "AQ": "Antarktika",
            "AG": "Antigua ve Barbuda",
            "AR": "Arjantin",
            "AM": "Ermenistan",
            "AW": "Aruba",
            "AU": "Avustralya",
            "AT": "Avusturya",
            "AZ": "Azerbaycan",
            "BS": "Bahamalar",
            "BH": "Bahreyn",
            "BD": "Bangladeş",
            "BB": "Barbados",
            "BY": "Belarus",
            "BE": "Belçika",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Butan",
            "BO": "Bolivya",
            "BA": "Bosna Hersek",
            "BW": "Botsvana",
            "BV": "Bouvet Adası",
            "BR": "Brezilya",
            "IO": "Britanya Hint Okyanusu Toprakları",
            "BN": "Brunei Sultanlığı",
            "BG": "Bulgaristan",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Kamboçya",
            "CM": "Kamerun",
            "CA": "Kanada",
            "CV": "Yeşil Burun Adaları",
            "KY": "Cayman Adaları",
            "CF": "Orta Afrika Cumhuriyeti",
            "TD": "Çad",
            "CL": "Şili",
            "CN": "Çin",
            "CX": "Noel Adası",
            "CC": "Cocos Adaları",
            "CO": "Kolombiya",
            "KM": "Komorlar",
            "CG": "Kongo",
            "CD": "Kongo Demokratik Cumhuriyeti",
            "CK": "Cook Adaları",
            "CR": "Kosta Rika",
            "CI": "Fildişi Sahili",
            "HR": "Hırvatistan",
            "CU": "Küba",
            "CY": "Kıbrıs",
            "CZ": "Çek Cumhuriyeti",
            "DK": "Danimarka",
            "DJ": "Cibuti",
            "DM": "Dominika",
            "DO": "Dominik Cumhuriyeti",
            "TP": "Doğu Timor",
            "EC": "Ekvador",
            "EG": "Mısır",
            "SV": "El Salvador",
            "GQ": "Ekvator Ginesi",
            "ER": "Eritre",
            "EE": "Estonya",
            "ET": "Etiyopya",
            "FK": "Falkland Adaları",
            "FO": "Faroe Adaları",
            "FJ": "Fiji",
            "FI": "Finlandiya",
            "FR": "Fransa",
            "GF": "Fransız Guyanası",
            "PF": "Fransız Polinezyası",
            "TF": "Fransız Güney Toprakları",
            "GA": "Gabon",
            "GM": "Gambiya",
            "GE": "Gürcistan",
            "DE": "Almanya",
            "GH": "Gana",
            "GI": "Cebelitarık",
            "GR": "Yunanistan",
            "GL": "Grönland",
            "GD": "Grenada",
            "GP": "Guadelup",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Gine",
            "GW": "Gine Bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HM": "Heard Adası ve Mcdonald Adaları",
            "VA": "Vatikan Şehir Devleti",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Macaristan",
            "IS": "İzlanda",
            "IN": "Hindistan",
            "ID": "Endonezya",
            "IR": "İran",
            "IQ": "Irak",
            "IE": "İrlanda",
            "IL": "İsrail",
            "IT": "İtalya",
            "JM": "Jamaika",
            "JP": "Japonya",
            "JO": "Ürdün",
            "KZ": "Kazakistan",
            "KE": "Kenya",
            "KI": "Kiribati",
            "KP": "Kore Demokratik Halk Cumhuriyeti",
            "KR": "Kore Cumhuriyeti",
            "KV": "Kosova",
            "KW": "Kuveyt",
            "KG": "Kırgızistan",
            "LA": "Lao Demokratik Halk Cumhuriyeti",
            "LV": "Letonya",
            "LB": "Lübnan",
            "LS": "Lesoto",
            "LR": "Liberya",
            "LY": "Libya Arap Cemahiriyesi",
            "LI": "Lihtenştayn",
            "LT": "Litvanya",
            "LU": "Lüksemburg",
            "MO": "Makao",
            "MK": "Makedonya",
            "MG": "Madagaskar",
            "MW": "Malavi",
            "MY": "Malezya",
            "MV": "Maldivler",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshall Adaları",
            "MQ": "Martinik",
            "MR": "Moritanya",
            "MU": "Mauritius",
            "YT": "Mayotte",
            "MX": "Meksika",
            "FM": "Mikronezya Federal Devletleri",
            "MD": "Moldova Cumhuriyeti",
            "MC": "Monako",
            "MN": "Moğolistan",
            "MS": "Montserrat",
            "ME": "Karadağ",
            "MA": "Fas",
            "MZ": "Mozambik",
            "MM": "Myanmar",
            "NA": "Namibya",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Hollanda",
            "AN": "Hollanda Antilleri",
            "NC": "Yeni Kaledonya",
            "NZ": "Yeni Zelanda",
            "NI": "Nikaragua",
            "NE": "Nijer",
            "NG": "Nijerya",
            "NU": "Niue",
            "NF": "Norfolk Adası",
            "MP": "Kuzey Mariana Adaları",
            "NO": "Norveç",
            "OM": "Umman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Filistin Toprakları",
            "PA": "Panama",
            "PG": "Papua Yeni Gine",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Filipinler",
            "PN": "Pitcairn",
            "PL": "Polonya",
            "PT": "Portekiz",
            "PR": "Porto Riko",
            "QA": "Katar",
            "RE": "Reunion",
            "RO": "Romanya",
            "RU": "Rusya Federasyonu",
            "RW": "Ruanda",
            "SH": "Aziz Helena",
            "KN": "Saint Kitts ve Nevis",
            "LC": "Saint Lucia",
            "PM": "Saint Pierre ve Miquelon",
            "VC": "Saint Vincent ve Grenadinler",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "Sao Tome ve Principe",
            "SA": "Suudi Arabistan",
            "SN": "Senegal",
            "RS": "Sırbistan",
            "SC": "Seyşeller",
            "SL": "Sierra Leone",
            "SG": "Singapur",
            "SK": "Slovakya",
            "SI": "Slovenya",
            "SB": "Solomon Adaları",
            "SO": "Somali",
            "ZA": "Güney Afrika",
            "GS": "Güney Georgia ve Güney Sandwich Adaları",
            "ES": "ispanya",
            "LK": "Sri Lanka",
            "SD": "Sudan",
            "SR": "Surinam",
            "SJ": "Svalbard ve Jan Mayen",
            "SZ": "Svaziland",
            "SE": "İsveç",
            "CH": "İsviçre",
            "SY": "Suriye Arap Cumhuriyeti",
            "TW": "Tayvan",
            "TJ": "Tacikistan",
            "TZ": "Tanzanya",
            "TH": "Tayland",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad ve Tobago",
            "TN": "Tunus",
            "TR": "Türkiye",
            "TM": "Türkmenistan",
            "TC": "Turks ve Caicos Adaları",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ukrayna",
            "AE": "Birleşik Arap Emirlikleri",
            "GB": "Birleşik Krallık",
            "US": "Amerika Birleşik Devletleri",
            "UM": "Amerika Birleşik Devletleri Küçük Dış Adaları",
            "UY": "Uruguay",
            "UZ": "Özbekistan",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "VG": "Britanya Virjin Adaları",
            "VI": "ABD Virjin Adaları",
            "WF": "Wallis ve Futuna",
            "EH": "Batı Sahra",
            "YE": "Yemen",
            "ZM": "Zambiya",
            "ZW": "Zimbabve"
        }
    }
};
exports.default = translations;
